export default "__VITE_ASSET__DW9NY$qR__"